export default __webpack_public_path__ + "static/media/img-9.97dcac3a.jpg";